<template>
  <div>
    <b-container style="margin-bottom: 100px">
      <b-container>
        <b-row align-h="around" class="margin-top">
          <b-col md="4"></b-col>
          <b-col md="4">
            <b-alert v-show="show_invalid_credential_message" class="invalid" show variant="danger">
              <span>{{$t('msg.invalid_credentials')}}</span>
            </b-alert>
            <b-form @submit.prevent="handleSubmit" class="border text-center">

              <b-form-group v-if="getBrandLogo()">
                <img :src="getProductBrandImageUrl()" height="85px" class="d-inline-block align-top" alt="logo"/>
              </b-form-group>

              <b-form-group id="user-name-input-group-1" style="margin-top:20px">
                <b-form-input v-model="username" name="username" v-validate="'required'"
                              id="username" type="text" @focus="changeState()"
                              :class="{'input': true, 'border-danger': errors.has('username') }"
                              :placeholder="$t('msg.username')"></b-form-input>

                <i v-show="errors.has('username')" class="fa fa-warning"></i>
                <span v-show="errors.has('username')" class="error">{{$t('msg.blank_username_field')}}</span>
              </b-form-group>

              <b-form-group id="password-input-group-2" class="pt-3">
                <b-input type="password" v-model="password" name="password" id="password" v-validate="'required'"
                         @focus="changeState()"
                         :class="{'input': true, 'border-danger': errors.has('password') }"
                         :placeholder="$t('msg.password')"></b-input>
                <i v-show="errors.has('password')" class="fa fa-warning"></i>
                <span v-show="errors.has('password')" class="error">{{$t('msg.blank_password_field')}}</span>
              </b-form-group>

              <b-form-group id="submit-group">
                <b-button :disabled="loggingIn" type="submit" variant="primary" class="button-size">
                  <b-spinner small v-show="loggingIn"></b-spinner>
                  {{$t('msg.enter') }}
                </b-button>
              </b-form-group>

            </b-form>
          </b-col>
          <b-col md="4"></b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import { apiUrl, rootUrl } from '../_config'
import { userService } from '../_services'

export default {
  data () {
    return {
      username: '',
      password: '',
      submitted: false,
      loggingIn: false,
      show_invalid_credential_message: false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  methods: {
    changeState: function () {
      this.show_invalid_credential_message = false
    },
    handleSubmit: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loggingIn = true
          userService.login(this.username, this.password)
            .then(response => {
              this.loggingIn = false
              window.location.href = rootUrl() + 'home'
            }).catch(error => {
              this.loggingIn = false
              console.log(error)
              this.show_invalid_credential_message = true
            })
        }
      })
    },
    getProductBrandImageUrl: function () {
      return apiUrl() + 'media/logo/' + this.getBrandLogo()
    },
    getBrandLogo: function () {
      if (this.$cookies.get('product_logo') && this.$cookies.get('product_logo').trim() !== '') {
        return this.$cookies.get('product_logo')
      }
      return undefined
    }
  },
  created: function () {
    let pageTitle = ''
    if (this.$cookies.get('product_name') && this.$cookies.get('product_name').trim() !== '') {
      pageTitle = this.$cookies.get('product_name')
    }
    document.title = pageTitle
  }
}
</script>

<style>
  .border {
    border: 1px solid black;
    background: rgba(255, 255, 255, .75);
    box-shadow: 1px 2px 10px -1px;
    margin-top: 10px;
    padding: 30px;
    /*height: 300px;*/
  }

  .button-size {
    margin-top: 50px;
    width: 80%;
  }

  .help .is-danger {
    color: red;
  }

  .borderColor {
    border-color: red;
  }

  .error {
    color: #f22435;
    font-size: 12px;
    float: left;
  }

  .invalid {
    font-size: 14px;
  }

</style>

<style scoped>

  .margin-top {
    margin-top: 100px;
  }

  @media screen and (min-height: 601px) and (max-height: 720px) {
    .margin-top {
      margin-top: 30px;
    }
  }

  @media screen and (max-height: 600px) {
    .margin-top {
      margin-top: 10px;
    }
  }

</style>
